/* PLUR launch — value-stories carousel + product-image magnifier zoom.
   Additive; no Dawn internals touched. */
(function () {
  // ----- value stories carousel -----
  document.querySelectorAll('[data-plur-stories]').forEach(function (box) {
    if (box.dataset.plurInit) return;   // guard: never bind twice
    box.dataset.plurInit = '1';
    var strip = box.querySelector('.plur-stories__strip');
    if (!strip) return;
    var slides = strip.children.length;
    var dotsBox = box.querySelector('.plur-stories__dots');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = parseInt(box.dataset.interval || '7000', 10);
    var i = 0, timer = null;

    for (var d = 0; d < slides; d++) {
      var b = document.createElement('button');
      b.className = 'plur-stories__dot' + (d === 0 ? ' is-on' : '');
      b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (d + 1));
      b.addEventListener('click', (function (n) { return function () { go(n); restart(); }; })(d));
      dotsBox.appendChild(b);
    }
    function go(n) {
      i = (n + slides) % slides;
      strip.style.transform = 'translateX(-' + (i * 100) + '%)';
      Array.prototype.forEach.call(dotsBox.children, function (el, k) {
        el.className = 'plur-stories__dot' + (k === i ? ' is-on' : '');
      });
    }
    function restart() {
      if (timer) clearInterval(timer);
      if (!reduced && box.dataset.autoplay === 'true') timer = setInterval(function () { go(i + 1); }, interval);
    }
    var prev = box.querySelector('[data-plur-prev]');
    var next = box.querySelector('[data-plur-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
    box.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    box.addEventListener('mouseleave', restart);

    // touch swipe (mobile): horizontal drag follows the finger, snaps on release
    var startX = 0, startY = 0, dx = 0, dragging = false, decided = false;
    box.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      dx = 0; dragging = true; decided = false;
      if (timer) clearInterval(timer);
      strip.style.transition = 'none';
    }, { passive: true });
    box.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var mx = e.touches[0].clientX - startX;
      var my = e.touches[0].clientY - startY;
      if (!decided) {
        // let vertical scrolling win unless the gesture is clearly horizontal
        if (Math.abs(my) > Math.abs(mx)) { dragging = false; strip.style.transition = ''; return; }
        decided = true;
      }
      dx = mx;
      strip.style.transform = 'translateX(calc(-' + (i * 100) + '% + ' + dx + 'px))';
    }, { passive: true });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      strip.style.transition = '';
      var threshold = Math.min(80, box.clientWidth * 0.18);
      if (dx <= -threshold) go(i + 1);
      else if (dx >= threshold) go(i - 1);
      else go(i);
      restart();
    }
    box.addEventListener('touchend', endDrag, { passive: true });
    box.addEventListener('touchcancel', endDrag, { passive: true });

    restart();
  });

  // ----- Globo card swatches: force small one-line circles.
  // Globo's stylesheet loads after ours and also uses !important, so CSS loses
  // the tie; inline styles win unconditionally. Observer catches late injection.
  function fixGloboCardSwatches() {
    // 1) Colour names EVERYWHERE: stash on the swatch (native title as fallback)
    document.querySelectorAll('.swatches-globo .swatch-anchor').forEach(function (a) {
      if (!a.dataset.plurTip) {
        var lab = a.querySelector('.attr-title-hover');
        var name = (lab ? lab.textContent : a.textContent || '').trim();
        if (name) { a.dataset.plurTip = name; a.title = name; }
      }
    });
    // 2) Card grids only: shrink to one-line 16px circles
    document.querySelectorAll('.card__information .swatches-globo .swatch-anchor').forEach(function (a) {
      if (a.dataset.plurSized) return;
      a.dataset.plurSized = '1';
      ['width', 'height'].forEach(function (p) { a.style.setProperty(p, '16px', 'important'); });
      a.style.setProperty('min-width', '0', 'important');
      a.style.setProperty('display', 'block', 'important');
      a.style.setProperty('box-sizing', 'border-box', 'important');
      a.querySelectorAll('*').forEach(function (s) {
        if (s.classList.contains('attr-title-hover')) { s.style.setProperty('display', 'none', 'important'); return; }
        s.style.setProperty('width', '100%', 'important');
        s.style.setProperty('height', '100%', 'important');
        s.style.setProperty('box-sizing', 'border-box', 'important');
      });
      var li = a.closest('li');
      if (li) { li.style.setProperty('height', '16px', 'important'); li.style.setProperty('line-height', '1', 'important'); }
    });
  }
  var plurSwatchTimer = null;
  function queueSwatchFix() { clearTimeout(plurSwatchTimer); plurSwatchTimer = setTimeout(fixGloboCardSwatches, 100); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueSwatchFix);
  else queueSwatchFix();
  new MutationObserver(queueSwatchFix).observe(document.documentElement, { childList: true, subtree: true });

  // ================= colour name → swatch background, harvested from the
  // Globo card swatches so the modal can reuse the store's real colours =======
  var PLUR_COLOURS = {};
  function harvestColours() {
    document.querySelectorAll('.swatches-globo .swatch-anchor').forEach(function (a) {
      var name = a.dataset.plurTip;
      if (!name || PLUR_COLOURS[name]) return;
      var probe = a.querySelector('span:not(.attr-title-hover)') || a;
      var cs = getComputedStyle(probe);
      var bg = cs.backgroundImage && cs.backgroundImage !== 'none' ? cs.backgroundImage : cs.backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)') PLUR_COLOURS[name] = bg;
    });
  }

  // ================= carry the chosen colour into the product/modal ==========
  // Clicking a card swatch must make "Choose options" (and the card link) open
  // that variant — otherwise the modal always shows the default colour.
  var productCache = {};
  function loadProduct(url) {
    var handle = url.split('?')[0];
    if (!productCache[handle]) {
      productCache[handle] = fetch(handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  function applyVariant(card, colourName) {
    var btn = card.querySelector('.quick-add__submit');
    var base = btn && btn.dataset.productUrl ? btn.dataset.productUrl.split('?')[0] : null;
    if (!base) {
      var link = card.querySelector('a.full-unstyled-link');
      base = link ? link.getAttribute('href').split('?')[0] : null;
    }
    if (!base) return;
    loadProduct(base).then(function (p) {
      if (!p || !p.variants) return;
      var idx = (p.options || []).findIndex(function (o) {
        var n = (o.name || o || '').toString().toLowerCase();
        return n === 'colour' || n === 'color' || n === 'couleur';
      });
      if (idx < 0) idx = 0;
      var match = p.variants.find(function (v) { return v.options[idx] === colourName; });
      if (!match) return;
      var url = base + '?variant=' + match.id;
      if (btn) btn.dataset.productUrl = url;
      card.querySelectorAll('a.full-unstyled-link, a.card__heading-link').forEach(function (a) {
        a.setAttribute('href', url);
      });
    });
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.swatches-globo .swatch-anchor');
    if (!sw) return;
    var card = sw.closest('.card-wrapper') || sw.closest('.card');
    if (!card) return;
    var name = sw.dataset.plurTip || (sw.textContent || '').trim();
    if (name) applyVariant(card, name);
  }, true);

  // ================= colour → its own photos ==================================
  // Shopify assigns each colour exactly ONE variant image (the front shot), but
  // Printful uploads three per colour (front / right-front / back) and encodes
  // the colour in the filename. So: take the colour's variant image, strip the
  // trailing view + hash to get its colour prefix, and claim every media file
  // sharing that prefix. Longest-prefix wins, so "navy" can't swallow
  // "navy-blue". Anything unmatched falls back to showing everything.
  var colourMediaCache = {};
  function colourMediaMap(handle, product) {
    if (colourMediaCache[handle]) return colourMediaCache[handle];
    var map = {};
    try {
      var cIdx = (product.options || []).findIndex(function (o) {
        var n = (o.name || o || '').toString().toLowerCase();
        return n === 'colour' || n === 'color' || n === 'couleur';
      });
      if (cIdx < 0) cIdx = 0;
      var stem = function (src) {
        var f = (src || '').split('/').pop().split('?')[0];
        return f.replace(/\.[a-z0-9]+$/i, '').replace(/-[0-9a-f]{8,}$/i, '');
      };
      var prefixes = [];      // {colour, prefix}
      product.variants.forEach(function (v) {
        var colour = v.options[cIdx];
        if (!colour || map[colour]) return;
        var fm = v.featured_media;
        if (!fm) return;
        map[colour] = [fm.id];
        // "unisex-staple-t-shirt-white-front" → "unisex-staple-t-shirt-white"
        var s = stem((fm.preview_image && fm.preview_image.src) || fm.src);
        prefixes.push({ colour: colour, prefix: s.replace(/-front$/, '') });
      });
      (product.media || []).forEach(function (m) {
        var s = stem(m.src);
        var best = null;
        prefixes.forEach(function (p) {
          if (!p.prefix) return;
          if (s === p.prefix || s.indexOf(p.prefix + '-') === 0) {
            if (!best || p.prefix.length > best.prefix.length) best = p;
          }
        });
        if (best && map[best.colour].indexOf(m.id) < 0) map[best.colour].push(m.id);
      });
    } catch (e) { map = {}; }
    colourMediaCache[handle] = map;
    return map;
  }
  function plurFilterGallery(modal) {
    var gallery = modal.querySelector('media-gallery');
    if (!gallery || !gallery.plurShow) return;
    var link = modal.querySelector('a[href*="/products/"]');
    if (!link) return;
    var handle = link.getAttribute('href').split('?')[0];
    var picked = modal.querySelector('fieldset.product-form__input input[type="radio"]:checked');
    var fs = picked ? picked.closest('fieldset') : null;
    var legend = fs ? fs.querySelector('legend') : null;
    var isColour = legend && /colou?r|couleur/i.test(legend.textContent);
    if (!picked || !isColour) return;
    var colour = picked.value;
    // No early-return on an unchanged colour: Dawn re-renders the modal on every
    // variant change and re-applies .quick-add-hidden, so the filter has to be
    // re-asserted each pass.
    gallery.dataset.plurColour = colour;
    loadProduct(handle).then(function (p) {
      if (!p) return;
      var map = colourMediaMap(handle, p);
      gallery.plurShow(map[colour] && map[colour].length ? map[colour] : null);
    });
  }

  // ================= quick-add modal: colour circles + image carousel ========
  function enhanceModal(modal) {
    harvestColours();

    // --- colour options as circles ---
    modal.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var label = legend ? legend.textContent.trim().toLowerCase() : '';
      if (label.indexOf('colour') < 0 && label.indexOf('color') < 0 && label.indexOf('couleur') < 0) return;
      var nameEl = fs.querySelector('.plur-colour-name');
      if (!nameEl && legend) {
        nameEl = document.createElement('span');
        nameEl.className = 'plur-colour-name';
        legend.appendChild(nameEl);
      }
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var lab = fs.querySelector('label[for="' + input.id + '"]');
        if (!lab || lab.dataset.plurSwatch) return;
        var colour = PLUR_COLOURS[input.value];
        if (!colour) return;                       // unknown colour → leave the pill alone
        lab.dataset.plurSwatch = '1';
        lab.classList.add('plur-swatch-opt');
        lab.style.setProperty(colour.indexOf('url(') === 0 ? 'background-image' : 'background-color', colour, 'important');
        lab.title = input.value;
        lab.setAttribute('aria-label', input.value);
        if (input.checked) { lab.classList.add('is-selected'); if (nameEl) nameEl.textContent = ': ' + input.value; }
        input.addEventListener('change', function () {
          fs.querySelectorAll('.plur-swatch-opt').forEach(function (l) { l.classList.remove('is-selected'); });
          lab.classList.add('is-selected');
          if (nameEl) nameEl.textContent = ': ' + input.value;
          plurFilterGallery(modal);          // show only this colour's photos
        });
      });
    });

    // --- image carousel: arrows, counter, swipe, and colour filtering ---
    var gallery = modal.querySelector('media-gallery');
    if (!gallery) return;
    // Dawn REPLACES the <li> media elements on every variant change, which
    // leaves our handles pointing at detached nodes. If any item isn't one we
    // set up, tear the controls down and rebuild against the live DOM.
    var liveItems = gallery.querySelectorAll('.product__media-item');
    var stale = Array.prototype.some.call(liveItems, function (it) { return !it.dataset.plurItem; });
    if (gallery.dataset.plurGallery && !stale) { plurFilterGallery(modal); return; }
    if (stale) {
      gallery.dataset.plurGallery = '';
      gallery.querySelectorAll('.plur-gal-btn, .plur-gal-dots').forEach(function (n) { n.remove(); });
    }
    var slider = gallery.querySelector('ul.product__media-list') || gallery.querySelector('ul');
    if (!slider) return;
    var allItems = Array.prototype.slice.call(slider.querySelectorAll('.product__media-item'));
    if (allItems.length < 2) return;
    allItems.forEach(function (it) { it.dataset.plurItem = '1'; });
    gallery.dataset.plurGallery = '1';
    gallery.classList.add('plur-gallery');

    // Dawn's quick-add script hides every image but the first with
    // .quick-add-hidden (display:none !important). Unhide them and lay the
    // list out as a track — inline styles so nothing overrides.
    var viewport = slider.parentElement;                 // <slider-component>
    viewport.style.setProperty('overflow', 'hidden', 'important');
    viewport.style.setProperty('display', 'block', 'important');
    slider.style.setProperty('display', 'flex', 'important');
    // Dawn's .grid sets flex-wrap:wrap — with 100%-wide items that stacks them
    // vertically instead of forming a horizontal track.
    slider.style.setProperty('flex-wrap', 'nowrap', 'important');
    slider.style.setProperty('overflow', 'visible', 'important');
    slider.style.setProperty('gap', '0', 'important');
    slider.style.setProperty('margin', '0', 'important');
    slider.style.setProperty('padding', '0', 'important');
    slider.style.setProperty('transition', 'transform .35s ease', 'important');
    allItems.forEach(function (it) {
      it.classList.remove('quick-add-hidden');
      it.style.setProperty('flex', '0 0 100%', 'important');
      it.style.setProperty('width', '100%', 'important');
      it.style.setProperty('max-width', '100%', 'important');
      it.style.setProperty('padding', '0', 'important');
    });

    var index = 0;
    var shown = allItems.slice();     // items visible for the current colour

    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'plur-gal-btn plur-gal-btn--prev';
    prev.setAttribute('aria-label', 'Previous image'); prev.textContent = '\u2039';
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'plur-gal-btn plur-gal-btn--next';
    next.setAttribute('aria-label', 'Next image'); next.textContent = '\u203a';
    var dots = document.createElement('div');
    dots.className = 'plur-gal-dots';
    gallery.appendChild(prev); gallery.appendChild(next); gallery.appendChild(dots);

    function paint() {
      var many = shown.length;
      prev.style.display = many > 1 ? '' : 'none';
      next.style.display = many > 1 ? '' : 'none';
      dots.style.display = many > 1 ? '' : 'none';
      if (many <= 6) {
        dots.classList.remove('plur-gal-count');
        if (dots.children.length !== many) {
          dots.textContent = '';
          shown.forEach(function (_, n) {
            var d = document.createElement('button');
            d.type = 'button'; d.setAttribute('aria-label', 'Image ' + (n + 1));
            d.addEventListener('click', function () { go(n); });
            dots.appendChild(d);
          });
        }
        Array.prototype.forEach.call(dots.children, function (d, n) {
          d.className = n === index ? 'is-on' : '';
        });
      } else {
        dots.classList.add('plur-gal-count');
        dots.textContent = (index + 1) + ' / ' + many;
      }
    }
    function go(n) {
      var max = shown.length - 1;
      index = n < 0 ? max : (n > max ? 0 : n);
      slider.style.setProperty('transform', 'translateX(-' + (index * 100) + '%)', 'important');
      paint();
    }
    gallery.plurShow = function (ids) {
      // ids = null → show everything; otherwise only media in that set
      shown = allItems.filter(function (it) {
        it.classList.remove('quick-add-hidden');    // Dawn re-adds this on re-render
        var keep = !ids || ids.some(function (id) { return (it.dataset.mediaId || '').indexOf(String(id)) >= 0; });
        it.style.setProperty('display', keep ? 'block' : 'none', 'important');
        return keep;
      });
      if (!shown.length) {                      // never end up with an empty gallery
        shown = allItems.slice();
        allItems.forEach(function (it) { it.style.setProperty('display', 'block', 'important'); });
      }
      go(0);
    };
    prev.addEventListener('click', function (e) { e.preventDefault(); go(index - 1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(index + 1); });

    // swipe on touch devices
    var sx = 0, sdx = 0, sdrag = false, sdecided = false;
    viewport.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sdx = 0; sdrag = true; sdecided = false;
      slider.style.setProperty('transition', 'none', 'important');
    }, { passive: true });
    viewport.addEventListener('touchmove', function (e) {
      if (!sdrag) return;
      var mx = e.touches[0].clientX - sx;
      if (!sdecided) { if (Math.abs(mx) < 8) return; sdecided = true; }
      sdx = mx;
      slider.style.setProperty('transform',
        'translateX(calc(-' + (index * 100) + '% + ' + sdx + 'px))', 'important');
    }, { passive: true });
    viewport.addEventListener('touchend', function () {
      if (!sdrag) return;
      sdrag = false;
      slider.style.setProperty('transition', 'transform .35s ease', 'important');
      var t = Math.min(70, viewport.clientWidth * 0.18);
      if (sdx <= -t) go(index + 1);
      else if (sdx >= t) go(index - 1);
      else go(index);
    }, { passive: true });

    go(0);
    plurFilterGallery(modal);
  }
  new MutationObserver(function () {
    document.querySelectorAll('quick-add-modal[open]').forEach(enhanceModal);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });

  // ----- instant colour tooltip: one floating element, shown the moment a
  // swatch is hovered (the native title tooltip has a ~1.5s OS delay) -----
  var plurTip = document.createElement('div');
  plurTip.className = 'plur-tip';
  if (document.body) document.body.appendChild(plurTip);
  else document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(plurTip); });
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('.swatches-globo .swatch-anchor');
    if (!a || !a.dataset.plurTip) { plurTip.style.display = 'none'; return; }
    var r = a.getBoundingClientRect();
    plurTip.textContent = a.dataset.plurTip;
    plurTip.style.left = (r.left + r.width / 2) + 'px';
    plurTip.style.top = (r.top - 7) + 'px';
    plurTip.style.display = 'block';
  });
  document.addEventListener('scroll', function () { plurTip.style.display = 'none'; }, true);

  // ----- magnifier zoom (2.5×, origin follows cursor) -----
  // Dawn covers the whole card with an invisible link overlay (the card
  // heading's a::after), so the cursor is never "on" .card__media and a
  // .card__media:hover CSS rule can never fire. Drive the zoom from the card
  // level in JS instead, with inline !important styles that nothing outranks.
  document.addEventListener('mousemove', function (e) {
    var card = e.target.closest && e.target.closest('.card');
    if (!card) return;
    var media = card.querySelector('.card__media');
    if (!media) return;
    var img = media.querySelector('img');
    if (!img) return;
    var r = media.getBoundingClientRect();
    var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    if (inside) {
      img.style.setProperty('transform-origin',
        ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%', 'important');
      img.style.setProperty('transform', 'scale(2.5)', 'important');
      img.style.setProperty('transition', 'transform .15s ease-out', 'important');
    } else {
      img.style.removeProperty('transform');
    }
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('.card');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    var img = card.querySelector('.card__media img');
    if (img) { img.style.removeProperty('transform'); img.style.removeProperty('transform-origin'); }
  });
})();

/* ---------- collection hero: mobile "read the full story" reveal (one-way) ---------- */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-plur-story-toggle]');
    if (!btn) return;
    var hero = btn.closest('.plur-chero');
    if (!hero) return;
    hero.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
  });
})();
